import type { ConditionValue } from '../../../configurator';
import type { FormField } from '../../contexts';

const SELECT_TYPES = ['choice', 'imageChoice', 'dropdown'];

export const checkValidCondition = (
  condition: ConditionValue,
  fields: FormField[]
) => {
  const { fieldID, condition: conditionValue, value } = condition;

  const conditionField = fields.find(({ id }) => id === fieldID);

  if (!conditionField) return false;

  const { type, options } = conditionField;

  const isEmptyOrNotEmpty = ['empty', 'notEmpty'].includes(
    conditionValue as string
  );

  const isComplete =
    (!!condition || type === 'thumbScale') && (!!value || isEmptyOrNotEmpty);

  const isConditionMet =
    !SELECT_TYPES.includes(type) ||
    isEmptyOrNotEmpty ||
    options?.some(({ id }) => id === value);

  return isComplete && isConditionMet;
};
